/**
 * Advisor-code normalization.
 *
 * ONE rule, applied on every side of the link so they cannot disagree:
 * remove all whitespace, then upper-case. The client typing the code, the
 * admin issuing it, and the SQL that matches it all use this rule — see
 * docs/FLP_ADVISOR_CODE_NORMALIZATION.sql for the database half.
 *
 * Codes are alphanumeric by convention (initials + a number), so removing
 * interior whitespace is safe and covers a code read aloud as "R C, one
 * hundred" and typed back as "RC 100".
 */
export function normalizeAdvisorCode(raw: string): string {
  return raw.replace(/\s+/g, "").toUpperCase();
}
